import LegalLayout from "@/components/LegalLayout";

export default function Disclaimer() {
  return (
    <LegalLayout
      testid="disclaimer-page"
      title="Disclaimer"
      lastUpdated="February 2026"
    >
      <p>
        The information provided by Brand-in-a-Box ("we", "us", "our") on this
        website and in connection with our services is for general
        informational and professional service purposes only.
      </p>

      <h2>No Income Guarantees</h2>
      <p>
        Brand-in-a-Box makes no representations, warranties, or guarantees of
        any kind regarding income, earnings, revenue, profit, or financial
        outcomes resulting from engagement of our services.
      </p>

      <h2>No Business Growth Guarantees</h2>
      <p>
        We do not guarantee any specific level of business growth, market
        penetration, customer acquisition, brand recognition, or competitive
        positioning.
      </p>

      <h2>No Lead Generation Guarantees</h2>
      <p>
        While our work is designed to support lead generation through stronger
        positioning and visual authority, we make no guarantees regarding the
        number, quality, or conversion rate of leads.
      </p>

      <h2>No Sales Guarantees</h2>
      <p>
        We do not guarantee any specific sales results, conversion rates, or
        revenue performance.
      </p>

      <h2>Results Vary by Client</h2>
      <p>
        Results depend on numerous factors outside our control — including
        the client's own marketing efforts, market conditions, offer
        quality, audience, pricing, execution speed, and consistency. Past
        client outcomes are not indicative of future results.
      </p>

      <h2>Professional Advice</h2>
      <p>
        Nothing on this website should be interpreted as legal, financial,
        accounting, or business advice. Clients should consult qualified
        professionals for advice relevant to their specific situation.
      </p>

      <h2>External Links</h2>
      <p>
        Our website may contain links to third-party sites. We are not
        responsible for the content, accuracy, or practices of any
        third-party site.
      </p>
    </LegalLayout>
  );
}
